import { render, staticRenderFns } from "./StoreSocialLinkForm.vue?vue&type=template&id=de9226d6&"
import script from "./StoreSocialLinkForm.vue?vue&type=script&lang=js&"
export * from "./StoreSocialLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports